import React from 'react';
import './NoDataComponent.scss';
import { ReactComponent as NoDataIcon } from '../../../images/no-data-2.svg';

interface NoDataComponentProps {
  name?: string;
}

const NoDataComponent: React.FC<NoDataComponentProps> = ({ name }) => {
  return (
    <section className='no-data-component'>
      <div className='no-data-component__content'>
        <NoDataIcon />
        <span className='no-data-component__message'>
          {name ? (
            <>
              <span className='no-data-component__name'>{name}</span> data is not available
            </>
          ) : (
            'Data currently not available'
          )}
        </span>
      </div>
    </section>
  );
};

export default NoDataComponent;
